export * from '@fhs/routing/src/routes/(root)/index';
export { default } from '@fhs/routing/src/routes/(root)/index';
